// import { stopAutoPlay } from "../../functions/Functions_GameBar";
// import { FireDrop } from "../Effects/fireDrop";

import { Howl } from "howler";
import { convertCreditsFromServerToClient } from "../../../../common/datastructures/Credits";
// import { convertCreditsFromServerToClient } from "../../../../common/datastructures/Credits";
// import { CommonData } from "../../../../common/datastructures/gamestate/gameData";
import { GameTextGeneral } from "../../../../common/datastructures/GameText";
import { createMovieClip } from "../../../../common/functions/Functions_General";
import { JumpingCoins } from "../../../../common/gameLib/JumpingCoin/jumpingCoinMain";
import { smallWinAnimation } from "../../../../common/gameLib/winAnimation/smallWinAnimator";
import { ImageText } from "../../../../common/ImageText";
import { GameData } from "../../gamestate/gameData";
import DeviceChecker from "../../../../common/functions/helper.ts/DeviceChecker";
// import { spotLight } from "../../background/bg_lights";

export class NewWinAnimation {
  private bg: PIXI.Sprite;
  private winText: Array<ImageText>;
  // private currency: ImageText;
  private winTextV2: Array<PIXI.Text>;
  private winTextV2Depth: Array<PIXI.Text>;
  private winTextTween: PIXI.tween.Tween;
  private parent: PIXI.Container;
  private nullContainer: PIXI.Container = new PIXI.Container(); //used for centering text
  private textContainer: PIXI.Container = new PIXI.Container();
  private coins: JumpingCoins;
  private counter: ImageText;
  private zoomingOutCounterTween: PIXI.tween.Tween;
  private incrementalScale: boolean;
  private counter_current: number;
  private counter_target: number;
  private counter_steps: number;
  private size: Array<number>;
  private ticker: PIXI.ticker.Ticker;
  private tickerPeriod: number;
  private tickerDelta: number;
  private winAmount: number;
  private betAmount: number;
  private ticker_totalDuration: number;
  private ticker_totalUpdates: number;
  private winAudio: Howl;
  private buildUpSuspense: Howl;
  private animationLength: number;
  private animationBaseDuration: number;
  private autoCloseTimeOut: any; //#endregion
  private animationActive: boolean = false;
  private winMultiplier: Array<number>;
  private activeGameData: GameData;
  private fx_absorbtion: Array<PIXI.Sprite>;
  private fx_absorbtionTween: Array<PIXI.tween.Tween>;

  private fx_absorbtionStar: Array<PIXI.Sprite>;
  private fx_absorbtionTweenStar: Array<PIXI.tween.Tween>;

  //---
  private newEffectsContainer: PIXI.Container;
  // private lights: Array<spotLight>;
  private shockwaveAnim: Array<PIXI.extras.AnimatedSprite>;

  // private bgLight: Array<PIXI.Sprite>;
  // private tintList: Array<number>;
  private counterContainer: PIXI.Container;
  private shakingCounterTween: PIXI.tween.Tween;
  private zoomTweenHeader: PIXI.tween.Tween;
  private abscorbtioContaion: PIXI.Container;

  // private recolorHueAngles: Array<number>;
  // private filterHue: PIXI.filters.ColorMatrixFilter;

  private includeSmallAnimation: boolean;
  private smallWinAnimation: smallWinAnimation;
  private smallAnimationsContainer: PIXI.Container;

  private bgScore: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgSmallWin.png")
  );
  // private lightSpin:PIXI.Sprite;
  // private lightSpinTween:PIXI.tween.Tween;

  private opticalFlare: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("lensFlare_Sparks.png")
  );
  private opticalFlareTween: PIXI.tween.Tween;
  private opticalFlareOutTween: PIXI.tween.Tween;
  private opticalExplosion: PIXI.extras.AnimatedSprite = createMovieClip(
    "expandBg",
    0,
    24
  );

  private bookofEgyptWinFrameParent: PIXI.Container = new PIXI.Container();
  private bigWinFrameEgyptBot: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bigWinFrameEgypt.png")
  );
  private bigWinFrameEgyptTop: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bigWinFrameEgypt.png")
  );
  private headerBg: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("frameBigWInHead.png")
  );
  private headerBgContainer: PIXI.Container = new PIXI.Container();
  private headerBgTween: PIXI.tween.Tween;
  private bigWinGoldPortalLight: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgFixedGold.png")
  );
  private bigWinGoldPortalLightTween: PIXI.tween.Tween;

  private bigWinBluePortalLight: PIXI.Sprite = new PIXI.Sprite(
    PIXI.Texture.fromFrame("bgFixed3.png")
  );
  private bigWinBluePortalLightTween: PIXI.tween.Tween;
  constructor(
    parent: PIXI.Container,
    // size: Array<number>,
    // gameVersion: string,
    activeGameData: GameData,
    incrementalScale: boolean = false
  ) {
    this.includeSmallAnimation = false;
    // this.tintList = [0x673ab7,0x00ffff, 0x00ff00, 0xffba01];
    // this.tintList = [0x00ff00, 0x00ffff, 0x673ab7, 0xffba01];
    this.activeGameData = activeGameData;
    this.winMultiplier = [20, 50, 100]; // [20, 50, 100];
    this.animationBaseDuration = 2500;
    let len = 3;
    this.animationLength = 0;
    this.winAmount = 0;
    this.betAmount = 0;
    this.parent = new PIXI.Container();
    this.incrementalScale = incrementalScale;
    parent.addChild(this.parent);

    this.size = activeGameData.size;

    this.bg = new PIXI.Sprite(PIXI.Texture.fromFrame("blackDot.png"));
    this.bg.blendMode = PIXI.BLEND_MODES.MULTIPLY;
    this.bg.anchor.set(0.5);
    // this.bg.scale.set(50);
    this.bg.scale.set(20);
    this.bg.alpha = 1;

    this.bg.on("pointertap", this.tapClose);
    this.parent.addChild(this.bg);
    this.abscorbtioContaion = new PIXI.Container();
    this.parent.addChild(this.abscorbtioContaion);
    this.createAbsorbtion();

    this.createSergioAnimationParts();

    //

    this.parent.addChild(this.bookofEgyptWinFrameParent);

    this.bookofEgyptWinFrameParent.addChild(this.bigWinFrameEgyptBot);
    this.bookofEgyptWinFrameParent.x = activeGameData.size[0] / 2;
    this.bookofEgyptWinFrameParent.y = activeGameData.size[1] / 2;
    this.bigWinFrameEgyptBot.anchor.set(0.5);
    this.bigWinFrameEgyptBot.y = 220;

    this.bookofEgyptWinFrameParent.addChild(this.bigWinFrameEgyptTop);
    this.bigWinFrameEgyptTop.anchor.set(0.5);
    this.bigWinFrameEgyptTop.scale.set(1, -1);
    this.bigWinFrameEgyptTop.y = -220;

    this.bookofEgyptWinFrameParent.addChild(this.bigWinGoldPortalLight);
    this.bigWinGoldPortalLight.anchor.set(0.5);
    this.bigWinGoldPortalLight.blendMode = PIXI.BLEND_MODES.ADD;
    this.bigWinGoldPortalLight.scale.set(2);

    this.bigWinGoldPortalLightTween = PIXI.tweenManager.createTween(
      this.bigWinGoldPortalLight
    );
    this.bigWinGoldPortalLightTween
      .from({ rotation: 0 })
      .to({ rotation: Math.PI * 2 });
    this.bigWinGoldPortalLightTween.time = 3000;
    this.bigWinGoldPortalLightTween.easing = PIXI.tween.Easing.linear();
    this.bigWinGoldPortalLightTween.loop = true;

    this.headerBgTween = PIXI.tweenManager.createTween(this.headerBgContainer);
    this.headerBgTween
      .from({ scale: { x: 0.5, y: 0.5 } })
      .to({ scale: { x: 1, y: 1 } });
    this.headerBgTween.time = 2500;
    this.headerBgTween.delay = 0;
    this.headerBgTween.easing = PIXI.tween.Easing.outElastic();
    this.headerBgTween.loop = false;

    //---portalfx
    this.bookofEgyptWinFrameParent.addChild(this.bigWinBluePortalLight);
    this.bigWinBluePortalLight.anchor.set(0.5);
    this.bigWinBluePortalLight.blendMode = PIXI.BLEND_MODES.ADD;
    this.bigWinBluePortalLight.scale.set(2);

    this.textContainer.addChild(this.headerBgContainer);
    // this.headerBgContainer.addChild(this.headerBg);
    this.headerBg.anchor.set(0.5, 0.96);
    this.headerBg.scale.set(1.2);
    this.headerBg.y = 80;

    this.bigWinBluePortalLightTween = PIXI.tweenManager.createTween(
      this.bigWinBluePortalLight
    );
    this.bigWinBluePortalLightTween
      .from({ rotation: 0 })
      .to({ rotation: Math.PI * 8 });
    this.bigWinBluePortalLightTween.time = 3000;
    this.bigWinBluePortalLightTween.easing = PIXI.tween.Easing.linear();
    this.bigWinBluePortalLightTween.loop = true;

    //--
    this.bg.position.set(this.size[0] / 2, this.size[1] / 2);

    this.parent.addChild(this.nullContainer);
    this.nullContainer.addChild(this.textContainer);

    this.parent.addChild(this.bgScore);
    this.counterContainer = new PIXI.Container();

    this.parent.addChild(this.counterContainer);

    this.setDefaultPositionCounters();

    // this.filterHue = new PIXI.filters.ColorMatrixFilter();
    // let colorMatrixSaturation = new PIXI.filters.ColorMatrixFilter();
    // let colorMatrixBrightness = new PIXI.filters.ColorMatrixFilter();
    // this.counterContainer.filters = [
    //   colorMatrixBrightness,
    //   this.filterHue,
    //   colorMatrixSaturation,
    // ];
    // this.nullContainer.filters = [
    //   colorMatrixBrightness,
    //   this.filterHue,
    //   colorMatrixSaturation,
    // ];
    // this.abscorbtioContaion.filters = [colorMatrixBrightness, this.filterHue,colorMatrixSaturation];

    // for (let i = 0; i < this.fx_absorbtion.length; i++) {
    //   this.fx_absorbtion[i].filters= [colorMatrixBrightness];
    //   this.fx_absorbtion[i].blendMode=PIXI.BLEND_MODES.ADD

    // }

    // this.recolorHueAngles=[270,180,110,0];
    // this.recolorHueAngles = [110, 180, 270, 0];

    // colorMatrixSaturation.saturate(1, false);
    // this.filterHue.hue(this.recolorHueAngles[2], false);
    // colorMatrixBrightness.brightness(2, false);

    this.nullContainer.position.set(this.size[0] / 2, this.size[1] / 2 - 100);

    this.winText = [];
    for (let i = 0; i < len; i++) {
      this.winText[i] = new ImageText("DEFAULT", this.textContainer);
      let scaleDiffrence = 0.75 / len; //
      if (this.incrementalScale) {
        // minimum scale is always over 50percent of scale
        this.winText[i].getParent().scale.set(0.2 + 0.65 + scaleDiffrence * i);
      }

      this.setPosition([0, 0]);
      this.winText[i].getParent().scale.set(0); //make the default invisible
    }

    this.createStyledText(activeGameData.gameTextGeneral);
    this.winAudio = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/win_hit.m4a?" + "version=" + this.activeGameData.gameVersion,
      ],
      volume: 0.5,
      loop: false,
      sprite: {
        win: [0, 3369],
      },
    });

    this.buildUpSuspense = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/tensionBuild.m4a?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.5,
      loop: false,
      sprite: {
        // tense: [0, 3097]
        tense: [0, this.animationBaseDuration],
      },
    });

    // this.winAudio.star()
    this.winTextTween = PIXI.tweenManager.createTween(this.textContainer);
    this.winTextTween
      .from({ scale: { x: 0, y: 0 } })
      .to({ scale: { x: 1, y: 1 } });
    this.winTextTween.time = 800;
    this.winTextTween.delay = 0;
    this.winTextTween.easing = PIXI.tween.Easing.outBack();
    this.winTextTween.loop = false;
    this.winTextTween.pingPong = false;
    // this.winTextTween.start()

    this.coins = new JumpingCoins(parent, this.size, 100);
    this.coins.setloop(false);
    // this.coins.startJump();

    this.activeGameData.soundList.push(this.winAudio);
    this.activeGameData.soundList.push(this.buildUpSuspense);
    this.activeGameData.soundList.push(this.coins.getCoinSound());

    this.bgScore.anchor.set(0.5);
    this.bgScore.scale.set(1.5);
    this.bgScore.position.set(this.counterContainer.x, this.counterContainer.y);

    this.counter = new ImageText("", this.counterContainer);
    this.counter.setScale(0.75);
    this.shakingCounterTween = PIXI.tweenManager.createTween(
      this.counterContainer
    );
    // this.shakingCounterTween.from({ x: 0, y: 0 }).to({ x: 20, y: 20 });
    this.shakingCounterTween.time = 100;
    this.shakingCounterTween.easing = PIXI.tween.Easing.linear();
    this.shakingCounterTween.loop = false;
    // this.shakingCounterTween.pingPong = true;
    this.shakingCounterTween.start();

    this.zoomingOutCounterTween = PIXI.tweenManager.createTween(
      this.counterContainer
    );
    this.zoomingOutCounterTween
      .from({ scale: { x: 1, y: 1 } })
      .to({ scale: { x: 1.2, y: 1 } });
    this.zoomingOutCounterTween.time = 1000;
    this.zoomingOutCounterTween.delay = 0;
    this.zoomingOutCounterTween.easing = PIXI.tween.Easing.inOutSine();
    this.zoomingOutCounterTween.loop = true;
    this.zoomingOutCounterTween.pingPong = true;
    // this.zoomingOutCounterTween.start();

    this.zoomTweenHeader = PIXI.tweenManager.createTween(this.nullContainer);
    this.zoomTweenHeader
      .from({ scale: { x: 0, y: 0 } })
      .to({ scale: { x: 1.2, y: 1.2 } });
    this.zoomTweenHeader.time = 10000;
    this.zoomTweenHeader.delay = 0;
    this.zoomTweenHeader.easing = PIXI.tween.Easing.linear();
    this.zoomTweenHeader.loop = false;
    this.zoomTweenHeader.pingPong = false;
    // this.zoomTweenHeader.start();

    this.tickerPeriod = 100; //updates 10 times per sec
    this.counter_current = 0;
    let durationWished = 5000; //counter animation duration
    let totalUpdates = durationWished / this.tickerPeriod;

    // console.log()
    this.counter_steps =
      (this.counter_target - this.counter_current) / totalUpdates / 100;

    // this.resetSteps();//---reset the interval
    this.tickerDelta = Date.now();
    this.ticker = new PIXI.ticker.Ticker();
    this.ticker.stop();
    this.ticker.add(() => {
      if (Date.now() - this.tickerDelta > this.tickerPeriod) {
        this.tickerDelta = Date.now();

        if (this.counter_current >= this.counter_target) {
          this.counter_current = this.counter_target;
          this.updateWIN(this.counter_current);
          this.ticker.stop();
          this.shakingCounterTween.stop();
          this.shakingCounterTween.clear();

          this.setDefaultPositionCounters();
          this.zoomingOutCounterTween.start();
        } else {
          // if (this.counter_current + this.counter_steps <= this.counter_target) {
          // console.log("sesst END", this.counter_current, this.counter_steps);
          this.updateWIN(this.counter_current);
          this.counter_current += this.counter_steps;

          if (this.shakingCounterTween.isEnded) {
            let randomPosX = Math.random() * 5 - 5;
            let randomPosY = Math.random() * 5 * -1;
            randomPosY > 0 ? (randomPosY += 20) : (randomPosY -= 10);
            this.shakingCounterTween
              .from({
                x: this.activeGameData.size[0] / 2,
                y: this.activeGameData.size[1] / 2 + 20,
              })
              .to({
                x: this.activeGameData.size[0] / 2 + randomPosX * 0,
                y: this.activeGameData.size[1] / 2 + randomPosY,
              });
          }
          this.shakingCounterTween.start();
        }
      }
    });

    this.counter.setNewText("0.00");

    //Default

    // this.setText(0, "BIG WIN");
    // this.setText(1, "SUPER WIN ");
    // this.setText(2, "MEGA WIN");

    this.setText;
    // this.setText(0, "BIG WIN");
    // this.setText(1, "MEGA WIN ");
    // this.setText(2, "EPIC WIN");

    this.parent.addChild(this.opticalFlare);
    this.opticalFlare.anchor.set(0.5);

    this.opticalFlare.scale.set(1.5);
    this.opticalFlare.blendMode = PIXI.BLEND_MODES.ADD;
    this.opticalFlare.alpha = 0;

    this.parent.addChild(this.opticalExplosion);
    this.opticalExplosion.anchor.set(0.5);
    this.opticalExplosion.scale.set(5);
    this.opticalExplosion.blendMode = PIXI.BLEND_MODES.ADD;
    this.opticalExplosion.gotoAndStop(0);
    this.opticalExplosion.loop = false;
    this.opticalExplosion.animationSpeed = 0.33;

    this.opticalFlare.x = activeGameData.size[0] / 2;
    this.opticalFlare.y = activeGameData.size[1] / 2;
    this.opticalExplosion.x = activeGameData.size[0] / 2;
    this.opticalExplosion.y = activeGameData.size[1] / 2;

    //-new effects
    this.opticalFlareTween = PIXI.tweenManager.createTween(this.opticalFlare);
    this.opticalFlareTween
      .from({ alpha: 1, scale: { x: 0, y: 0 } })
      .to({ alpha: 1, scale: { x: 5, y: 5 }, rotation: 0 });
    this.opticalFlareTween.time = 500;
    // this.tweenBookShake.delay = 1000;
    this.opticalFlareTween.loop = false;
    this.opticalFlareTween.easing = PIXI.tween.Easing.linear();

    this.opticalFlareOutTween = PIXI.tweenManager.createTween(
      this.opticalFlare
    );
    this.opticalFlareOutTween
      .from({ alpha: 1, scale: { x: 3, y: 3 } })
      .to({ alpha: 0, scale: { x: 5.5, y: 5.5 }, rotation: Math.PI });
    this.opticalFlareOutTween.time = 1000;
    // this.opticalFlareOutTween.delay = 1000;
    this.opticalFlareOutTween.loop = false;
    this.opticalFlareOutTween.easing = PIXI.tween.Easing.linear();
    this.opticalFlareTween.chain(this.opticalFlareOutTween);

    this.stop();

    //-
    //    this.playFire()
  }
  private displayBgPortal = (bool: boolean): void => {
    if (bool) {
      this.headerBg.scale.set(0);
      this.bookofEgyptWinFrameParent.alpha = 1;
      this.opticalFlare.alpha = 0;
      this.bigWinGoldPortalLightTween.start();
      this.bigWinBluePortalLightTween.start();

      this.nullContainer.alpha = 1;
    } else {
      this.nullContainer.alpha = 0;
      this.headerBg.scale.set(0);
      this.bookofEgyptWinFrameParent.alpha = 0;
      this.opticalFlare.alpha = 0;
      this.bigWinGoldPortalLightTween.stop();
      this.bigWinBluePortalLightTween.stop();
    }
  };
  private playShockWaveEgypt = (bool: boolean): void => {
    if (bool) {
      this.opticalExplosion.gotoAndPlay(0);

      this.opticalFlareTween.start();
    } else {
      this.opticalExplosion.gotoAndStop(0);

      this.opticalFlareTween.stop();
      this.opticalFlareTween.reset();
    }
  };
  private setDefaultPositionCounters = (): void => {
    this.counterContainer.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
  };

  public getMultiplier = (): Array<number> => {
    return this.winMultiplier;
  };
  public createSergioAnimationParts = (): void => {
    //---new features

    this.newEffectsContainer = new PIXI.Container();
    this.newEffectsContainer.x = this.activeGameData.size[0] / 2;
    this.newEffectsContainer.y = this.activeGameData.size[1] / 2; //-250;
    this.parent.addChild(this.newEffectsContainer);
    // let tints=
    this.shockwaveAnim = [];
    // this.bgLight = [];
    let shockWaveScale = 1;
    // let lightArrayScale = 0.7;
    for (let i = 0; i < 4; i++) {
      // this.bgLight[i] = new PIXI.Sprite(
      //   PIXI.Texture.fromFrame("bgLightTile.png")
      // );
      // this.bgLight[i].anchor.set(1);
      // this.bgLight[i].tint = this.tintList[0]; //0xff0000;
      // this.bgLight[i].blendMode = PIXI.BLEND_MODES.ADD;
      // this.bgLight[i].scale.set(lightArrayScale);
      // this.bgLight[i].alpha = 0.5;
      // this.newEffectsContainer.addChild(this.bgLight[i]);

      this.shockwaveAnim[i] = createMovieClip("shockWaveAnimated", 0, 30);
      // this.shockwaveAnim[i] = createMovieClip("FireDrop", 0, 21);
      this.shockwaveAnim[i].anchor.set(0);
      this.shockwaveAnim[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.shockwaveAnim[i].scale.set(shockWaveScale);
      this.shockwaveAnim[i].animationSpeed = 0.35;
      this.newEffectsContainer.addChild(this.shockwaveAnim[i]);
      this.shockwaveAnim[i].loop = false;
      this.shockwaveAnim[i].gotoAndStop(0);
      this.shockwaveAnim[i].alpha = 0;
      // this.shockwaveAnim[i].tint = this.tintList[0]; //0xff0000;
    }

    // this.bgLight[1].scale.set(-lightArrayScale, lightArrayScale);
    // this.bgLight[2].scale.set(-lightArrayScale, -lightArrayScale);
    // this.bgLight[3].scale.set(lightArrayScale, -lightArrayScale);

    this.shockwaveAnim[1].scale.set(-shockWaveScale, shockWaveScale);
    this.shockwaveAnim[2].scale.set(-shockWaveScale, -shockWaveScale);
    this.shockwaveAnim[3].scale.set(shockWaveScale, -shockWaveScale);

    this.playShockWave; //(true);
  };

  private playShockWave = (bool: boolean): void => {
    for (let i = 0; i < this.shockwaveAnim.length; i++) {
      bool
        ? this.shockwaveAnim[i].gotoAndPlay(0)
        : this.shockwaveAnim[i].gotoAndStop(0);
      this.shockwaveAnim[i].alpha = bool ? 1 : 0;
    }

    //play new shockwave
    this.playShockWaveEgypt(bool);
  };

  private setShockWaveScale = (shockWaveScale: number): void => {
    this.shockwaveAnim[0].scale.set(shockWaveScale);
    this.shockwaveAnim[1].scale.set(-shockWaveScale, shockWaveScale);
    this.shockwaveAnim[2].scale.set(-shockWaveScale, -shockWaveScale);
    this.shockwaveAnim[3].scale.set(shockWaveScale, -shockWaveScale);
  };
  // private setNewTint = (index: number): void => {
  //   // tintList
  //   //-define the tint for all elements
  //   let newTint = this.tintList[index];
  //   //tint spotlights

  //   for (let index = 0; index < this.shockwaveAnim.length; index++) {
  //     this.shockwaveAnim[index].tint = newTint;
  //   }
  // };
  public setNewMultiplierWin = (
    small: number,
    medium: number,
    big: number
  ): void => {
    this.winMultiplier = [small, medium, big];
  };
  // public setCurrency = (): void => {
  //   this.currency.setNewText(this.activeGameData.currency);
  //   this.currency
  //     .getParent()
  //     .position.set(
  //       -this.currency.getParent().width / 2,
  //       this.currency.getParent().height
  //     );
  // };

  private createAbsorbtion = (): void => {
    let maxFxCount = 3;
    this.fx_absorbtion = [];
    this.fx_absorbtionTween = [];

    for (let i = 0; i < maxFxCount; i++) {
      this.fx_absorbtion[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame("ZoomingFx.png")
      );
      // this.fx_absorbtion.tint=(0xffcc00)
      this.fx_absorbtion[i].anchor.set(0.5);
      this.fx_absorbtion[i].position.set(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[1] / 2
      );
      this.abscorbtioContaion.addChild(this.fx_absorbtion[i]);
      this.fx_absorbtion[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.fx_absorbtion[i].rotation = (Math.random() * 360 * Math.PI) / 180;
      this.fx_absorbtion[i].alpha = 0;
      this.fx_absorbtionTween[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtion[i]
      );
      this.fx_absorbtionTween[i]
        .from({ scale: { x: 8, y: 8 }, alpha: 0 })
        .to({ scale: { x: 0, y: 0 }, alpha: 1 });
      this.fx_absorbtionTween[i].time = 500;
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTween[i].delay)
      this.fx_absorbtionTween[i].easing = PIXI.tween.Easing.linear();
      this.fx_absorbtionTween[i].loop = false;
    }

    for (let i = 0; i < this.fx_absorbtionTween.length; i++) {
      if (i < this.fx_absorbtionTween.length - 1) {
        this.fx_absorbtionTween[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > 0.5) {
              tween.start();
            }
          }.bind(this.fx_absorbtionTween[i], this.fx_absorbtionTween[i + 1])
        );
      }
      let lastAnim = this.fx_absorbtionTween.length - 1;
      this.fx_absorbtionTween[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > 0.5) {
            tween.start();
          }
        }.bind(this.fx_absorbtionTween[lastAnim], this.fx_absorbtionTween[0])
      );
    }

    this.fx_absorbtionStar = [];
    this.fx_absorbtionTweenStar = [];

    for (let i = 0; i < maxFxCount; i++) {
      this.fx_absorbtionStar[i] = new PIXI.Sprite(
        PIXI.Texture.fromFrame("ZoomingFxStars.png")
      );

      // this.fx_absorbtionStar[i] = new PIXI.Sprite(
      //   PIXI.Texture.fromFrame("coins_000"+Math.floor(Math.random()*30+10)+".png")
      // );
      // this.fx_absorbtion.tint=(0xffcc00)
      this.fx_absorbtionStar[i].anchor.set(0.5);
      this.fx_absorbtionStar[i].position.set(
        this.activeGameData.size[0] / 2,
        this.activeGameData.size[1] / 2
      );
      this.abscorbtioContaion.addChild(this.fx_absorbtionStar[i]);
      this.fx_absorbtionStar[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.fx_absorbtionStar[i].rotation =
        (Math.random() * 360 * Math.PI) / 180;
      this.fx_absorbtionStar[i].alpha = 0;
      this.fx_absorbtionTweenStar[i] = PIXI.tweenManager.createTween(
        this.fx_absorbtionStar[i]
      );
      this.fx_absorbtionTweenStar[i]
        .from({ scale: { x: 4, y: 4 }, alpha: 1 })
        .to({ scale: { x: 0, y: 0 }, alpha: 1 });
      this.fx_absorbtionTweenStar[i].time = 1000;
      // this.fx_absorbtionTween[i].delay =  this.fx_absorbtionTween[i].time*(i*maxFxCount);
      // console.log(this.fx_absorbtionTweenStar[i].delay)
      this.fx_absorbtionTweenStar[i].easing = PIXI.tween.Easing.linear();
      this.fx_absorbtionTweenStar[i].loop = false;
    }

    for (let i = 0; i < this.fx_absorbtionTweenStar.length; i++) {
      if (i < this.fx_absorbtionTweenStar.length - 1) {
        this.fx_absorbtionTweenStar[i].on(
          "update",
          function(tween: PIXI.tween.Tween, elapsedTime: number) {
            if (elapsedTime > 0.5) {
              tween.start();
            }
          }.bind(
            this.fx_absorbtionTweenStar[i],
            this.fx_absorbtionTweenStar[i + 1]
          )
        );
      }
      let lastAnim = this.fx_absorbtionTweenStar.length - 1;
      this.fx_absorbtionTweenStar[lastAnim].on(
        "update",
        function(tween: PIXI.tween.Tween, elapsedTime: number) {
          if (elapsedTime > 0.5) {
            tween.start();
          }
        }.bind(
          this.fx_absorbtionTweenStar[lastAnim],
          this.fx_absorbtionTweenStar[0]
        )
      );
    }
  };

  private playFire = (bool: boolean): void => {
    // this.ticker_AnimationFx.start();
    for (let index = 0; index < this.fx_absorbtionTween.length; index++) {
      if (bool) {
        // this.fx_absorbtionTween[index].reset();
        // this.fx_absorbtionTween[index].start();
        this.fx_absorbtionTween[index].reset();
        this.fx_absorbtionTween[0].start();

        this.fx_absorbtionTweenStar[index].reset();
        this.fx_absorbtionTweenStar[0].start();
      } else {
        this.fx_absorbtionTween[index].stop();
        this.fx_absorbtionTween[index].reset();
        this.fx_absorbtion[index].alpha = 0;

        this.fx_absorbtionTweenStar[index].stop();
        this.fx_absorbtionTweenStar[index].reset();
        this.fx_absorbtionStar[index].alpha = 0;
      }
    }
  };

  private createStyledText(lang: GameTextGeneral) {
    this.winTextV2 = [];
    this.winTextV2Depth = [];

    let textStyle = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 150,
      fill: ["#fffb93", "#f8ee6f", "#975333", "#965135"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#e2a84b",
      strokeThickness: 3,
      dropShadow: true,
      dropShadowColor: "#000000",
      // dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    let textStyle2 = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 150,
      fill: ["#a03f36", "#7c2625"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#7c2625",
      strokeThickness: 3,
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 2,
      dropShadowDistance: 5,
    });

    this.winTextV2[0] = new PIXI.Text(lang.bigWin, textStyle);
    this.winTextV2[1] = new PIXI.Text(lang.superWin, textStyle);
    this.winTextV2[2] = new PIXI.Text(lang.megaWin, textStyle);

    this.winTextV2Depth[0] = new PIXI.Text(lang.bigWin, textStyle2);
    this.winTextV2Depth[1] = new PIXI.Text(lang.superWin, textStyle2);
    this.winTextV2Depth[2] = new PIXI.Text(lang.megaWin, textStyle2);

    this.winTextV2[0].y -= 10;
    this.winTextV2[1].y -= 10;
    this.winTextV2[2].y -= 10;

    this.winTextV2Depth[0].y = this.winTextV2[0].y + 10;
    this.winTextV2Depth[1].y = this.winTextV2[1].y + 10;
    this.winTextV2Depth[2].y = this.winTextV2[2].y + 10;

    this.textContainer.addChild(this.winTextV2Depth[0]);
    this.textContainer.addChild(this.winTextV2Depth[1]);
    this.textContainer.addChild(this.winTextV2Depth[2]);
    this.winTextV2Depth[0].addChild(this.winTextV2[0]);
    this.winTextV2Depth[1].addChild(this.winTextV2[1]);
    this.winTextV2Depth[2].addChild(this.winTextV2[2]);

    //center text
    this.winTextV2Depth[0].scale.set(0.7);
    this.winTextV2Depth[1].scale.set(0.85);
    //set maxwidth

    for (let index = 0; index < this.winTextV2Depth.length; index++) {
      if (this.winTextV2Depth[index].width > this.activeGameData.size[0]) {
        this.winTextV2Depth[index].width = this.activeGameData.size[0] - 200;
      }
      this.winTextV2Depth[index].x = -this.winTextV2Depth[index].width / 2;
      this.winTextV2Depth[index].y =
        -this.winTextV2Depth[index].height / 2 - 100;
    }

    if (this.includeSmallAnimation) {
      this.createSmallWin();
    }
  }
  private createSmallWin = (): void => {
    this.smallAnimationsContainer = new PIXI.Container();
    this.activeGameData.gameSceneBonus.addChild(this.smallAnimationsContainer);

    this.smallWinAnimation = new smallWinAnimation(
      this.smallAnimationsContainer
    );

    this.smallWinAnimation.setPosition([
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2,
    ]);
  };
  public setIncludeSmallAnimations = (bool: boolean): void => {
    this.includeSmallAnimation = bool;
    if (bool && this.smallAnimationsContainer == undefined) {
      this.createSmallWin();
    }
  };
  private setText = (index: number, newText: string): void => {
    // console.log("===>>", newText);
    this.winText[index].setNewText(newText);
    //recenter
    let par = this.winText[index].getParent();
    par.x = -par.width / 2;
    if (index == 1) {
      par.x += 60;
    }
  };
  private setVisible(index: number) {
    if (this.winText[index].getParent().alpha == 0) {
      this.winText[index].setAlpha(1);
      this.winTextV2Depth[index].alpha = 1;
      this.textContainer.scale.set(0);
      this.winTextTween.reset();
      this.winTextTween.start();

      this.headerBgTween.reset();

      let scaleTween = index * 0.15 + 1.1;
      this.headerBgTween
        .from({ scale: { x: 0.5, y: 0.5 } })
        .to({ scale: { x: scaleTween, y: scaleTween } });

      this.headerBgTween.start();

      this.buildUpSuspense.stop();

      this.winAudio.stop();
      this.winAudio.play("win");
      // this.setNewTint(2);
      if (this.animationLength === index) {
        // console.log(this.animationLength, index);
        this.coins.startJump();

        // this.ticker_AnimationFx.stop();
        this.playFire(false);
        // let self = this;
        // this.autoCloseTimeOut = setInterval(this.stop, 4000);
        this.autoCloseTimeOut = setTimeout(() => {
          if (this.activeGameData.mainGame != undefined) {
            // this.activeGameData.mainGame.getExpandAnimation().onSkipClick();
            this.activeGameData.mainGame.checkMessageToDisplay();
          }
          this.stop();
        }, 6000);
      } else {
        this.buildUpSuspense.stop();
        this.buildUpSuspense.play("tense");
        this.playFire(true);
      }
    }

    for (let i = 0; i < this.winText.length; i++) {
      if (i != index && this.winText[i].getParent().alpha == 1) {
        this.winText[i].getParent().alpha = 0;
        this.winTextV2Depth[i].alpha = 0;
      }
    }

    // this.updateWIN(winAmount)
  }

  private setAllHidden() {
    for (let i = 0; i < this.winText.length; i++) {
      this.winText[i].setAlpha(0);
      this.winTextV2Depth[i].alpha = 0;
    }
    this.bg.alpha = 0;
    this.bgScore.alpha = 0;
  }
  // public getTextImgWidth=(index:number):ImageText=>
  // {
  //     return this.winText[index];
  // }
  private setPosition = (newPos: Array<number>): void => {
    for (let i = 0; i < this.winText.length; i++) {
      // this.winText[i];
      let par = this.winText[i].getParent();
      par.x = newPos[0] - par.width / 2;
      par.y = newPos[1] - par.height / 2;
    }
  };

  public stop = (): void => {
    // this.activeGameData.playable=true
    // if(this.isActive())
    // {
    this.activeGameData.blackScreen2.setVisible(false);
    this.enableTapToClose(false);
    // console.log("stop win")
    this.ticker.stop();
    this.coins.stop();
    this.headerBgTween.stop();
    this.winTextTween.stop();
    this.setAllHidden(); //hides all the  text like mega /win
    this.counter.getParent().alpha = 0;
    this.winAmount = 0;
    this.betAmount = 0;
    this.counter_steps = 0;
    this.winAudio.stop();
    this.buildUpSuspense.stop();

    // clearInterval(this.autoCloseTimeOut);
    clearTimeout(this.autoCloseTimeOut);
    // if (this.animationActive) { console.log('real Duration: ', Date.now() - this.testTimer - 4000) }
    this.animationActive = false;
    // this.ticker_AnimationFx.stop();
    this.playFire(false);
    // this.currency.setAlpha(0);
    if (this.activeGameData.splashScreenBonusCheck != undefined) {
      this.activeGameData.splashScreenBonusCheck();
    }
    //--
    this.newEffectsContainer.alpha = 0;
    // this.setNewTint(0);

    this.zoomingOutCounterTween.stop();
    this.zoomingOutCounterTween.reset();

    if (this.includeSmallAnimation) {
      this.smallWinAnimation.clear();
    }
    this.playShockWaveEgypt(false);
    this.displayBgPortal(false);

    // }
    // if(this.activeGameData.mainGame!=undefined)
    // {

    //   console.log(" big win close  display")
    //   this.activeGameData.mainGame.checkMessageToDisplay();
    // }
  };
  private updateWIN = (newVal: number): void => {
    // newVal
    // console.log(newVal);
    // console.log(this.counter_steps)

    if (this.bg.alpha == 0) {
      this.bg.alpha = 0.75;
      this.bgScore.alpha = 1;
    }
    this.counter.setNewText(
      (newVal / 100).toFixed(2) + this.activeGameData.currency
    );

    this.counter.setAnchor([0.5, 0.5]);
    this.counter.setSpacing(110);

    let par = this.counter.getParent();
    par.alpha = 1;
    ///-end Position

    par.x = -par.width / 2 + 120;
    // par.y = 300;

    let multiplier = this.counter_current / this.betAmount;

    if (multiplier >= this.winMultiplier[2]) {
      this.playFire(false);

      //megawin
      // this.showEndSergio()
      // console.log(multiplier,this.counter_current,this.betAmount)
      if (this.winText[2].getParent().alpha == 0) {
        this.setVisible(2);
        this.checkBoost(2);
        this.setShockWaveScale(1.5);
        this.playShockWave(true);

        // this.setNewTint(3);
        // this.filterHue.hue(this.recolorHueAngles[3], false);
        this.autoScaleTheHeader(2);
      }
      //--stop autoplay test
      // stopAutoPlay(this.activeGameData);
    } else if (multiplier >= this.winMultiplier[1]) {
      this.playFire(false);
      //superwin
      if (this.winText[1].getParent().alpha == 0) {
        this.setVisible(1);
        this.counter_steps *= 5 / 3;
        this.checkBoost(1);
        this.setShockWaveScale(1.5);
        this.playShockWave(true);

        // this.setNewTint(2);
        // this.filterHue.hue(this.recolorHueAngles[2], false);

        this.autoScaleTheHeader(1);
      }
      //--stop autoplay test
      // stopAutoPlay(this.activeGameData);
    } else if (multiplier >= this.winMultiplier[0]) {
      this.playFire(false);
      //bigwin
      if (this.winText[0].getParent().alpha == 0) {
        this.setVisible(0);
        this.setShockWaveScale(1.5);
        this.playShockWave(true);
        this.counter_steps *= 3 / 2;
        this.checkBoost(0);
        // this.setNewTint(1);
        // this.filterHue.hue(this.recolorHueAngles[1], false);

        this.autoScaleTheHeader(0);
      }
    }
  };

  public autoScaleTheHeader = (index: number): void => {
    // console.log(this.winTextV2Depth[index].width)
    this.headerBg.width = this.winTextV2Depth[index].width * 1.3;
    this.headerBg.scale.y = 0.8;
    this.headerBg.scale.x = 1;
    if (this.headerBg.scale.x < 1) {
      this.headerBg.scale.x = 1;
    }
  };
  public checkBoost = (index: number): void => {
    // from current to target  boost speed
    if (this.animationLength == index) {
      //console.log
      this.ticker_totalDuration = 500; //new duration to go to end
      this.ticker_totalUpdates = this.ticker_totalDuration / this.tickerPeriod;
      this.counter_steps =
        (this.counter_target - this.counter_current) / this.ticker_totalUpdates;
      // console.log(this.counter_steps)
    }
  };

  private enableTapToClose = (bool: boolean): void => {
    this.bg.buttonMode = bool;
    this.bg.interactive = bool;
  };

  public displayWin = (winAmount: number, bet: number): void => {
    if (this.animationActive == false) {
      // this.stop();
      // this.filterHue.hue(this.recolorHueAngles[0], false);
      let multiplier = winAmount / bet;
      // console.log("---",winAmount,bet,multiplier)
      // if (multiplier >= this.winMultiplier[0]) {
      if (multiplier >= this.winMultiplier[0]) {
        this.activeGameData.blackScreen2.setVisible(true);
        this.displayBgPortal(true);

        this.newEffectsContainer.alpha = 1;
        // this.testTimer = Date.now();

        // this.currency.setAlpha(1);
        this.buildUpSuspense.stop();
        this.buildUpSuspense.play("tense");
        this.playFire(true);
        this.winAmount = winAmount;
        this.betAmount = bet;
        this.counter_target = this.winAmount;
        if (this.winAmount > 0) {
          this.animationActive = true;
        }

        this.animationLength = 0;
        if (multiplier >= this.winMultiplier[2]) {
          this.animationLength = 2;
        } else if (multiplier >= this.winMultiplier[1]) {
          this.animationLength = 1;
        }
        this.enableTapToClose(true);

        this.counter_current = 0;
        // this.tickerPeriod = 100;   //updates 10 times per sec
        this.ticker_totalDuration =
          this.animationBaseDuration * (this.animationLength + 1);

        this.ticker_totalUpdates =
          this.ticker_totalDuration / this.tickerPeriod;
        // this.counter_steps = (this.counter_target - this.counter_current) / this.ticker_totalUpdates;//base  that get multiplied
        this.counter_steps =
          (this.winMultiplier[this.animationLength] * bet -
            this.counter_current) /
          this.ticker_totalUpdates; //for constant speed upto x100
        // console.log(this.animationLength,(this.winMultiplier[this.animationLength])*bet)

        this.ticker.start();
      } else {
        //----check if bonus game msg needs to be shown when the bonus win is less than x20 times
        if (this.activeGameData.splashScreenBonusCheck != undefined) {
          this.activeGameData.splashScreenBonusCheck();
        }
        if (this.includeSmallAnimation) {
          if (winAmount > 0) {
            let winValue = convertCreditsFromServerToClient(winAmount).toFixed(
              2
            );
            this.smallWinAnimation.updatewinAmountText(
              winValue + this.activeGameData.currency
            );
            this.smallWinAnimation.playShockWave(true);
          }
        }
      }
    }
  };

  private tapClose = (): void => {
    // console.log("CLOSE")
    if (this.activeGameData.mainGame != undefined) {
      // this.activeGameData.mainGame.getExpandAnimation().onSkipClick();
      this.activeGameData.mainGame.checkMessageToDisplay();
    }
    this.stop();
  };

  public getAudioHit = (): Howl => {
    return this.winAudio;
  };

  public getAudioTension = (): Howl => {
    return this.buildUpSuspense;
  };
  public getAudioCoin = (): Howl => {
    return this.coins.getCoinSound();
  };

  public isActive = (): boolean => {
    return this.animationActive;
  };
  public isBigWin = (winAmount: number, stake: number): boolean => {
    let multiplier = winAmount / stake;
    if (multiplier >= this.winMultiplier[0]) {
      return true;
    } else {
      return false;
    }
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  // public setMultiplier(newArray: Array<number>) {
  //     this.winMultiplier = newArray;
  // }
}
